// src/services/espacioServicioHistoryService.ts
import { axiosInstance } from './axiosConfig';
import { handleRequestWithAuth } from './refreshService';

const HISTORY_API_URL = 'espacio-servicios-history/';

// Tipo TypeScript para el historial
export interface EspacioServicioHistory {
    id: number;
    user_email: string;
    user_full_name: string;
    espacio_servicio: string;
    espacio_name: string;
    servicio_name: string;
    action: 'created' | 'updated' | 'deleted';
    timestamp: string;
    changes: {
        espacio?: { old: string, new: string };
        servicio?: { old: string, new: string };
        estado?: { old: boolean, new: boolean };
        fecha_creacion?: { old: string, new: string };
    } | null;
}

// Obtener todo el historial de relaciones espacio-servicio
export const fetchEspacioServicioHistory = async (): Promise<EspacioServicioHistory[]> => {
    return handleRequestWithAuth(async () => {
        const response = await axiosInstance.get<EspacioServicioHistory[]>(HISTORY_API_URL);
        return response.data;
    });
};